import TWEEN from 'tween.js'
import { GUI } from 'three/examples/jsm/libs/dat.gui.module'
import { config } from './config'

export class GUITool {
  constructor () {
    // 获取config里需要调试的值
    // damping动画时间、拖拽力度（damping里的todo参数）、变换函数（damping动画里值的变化曲线函数）
    // 首先把这三个都扔到config里作为常量
    // 然后把值传入config，这里绑定GUI，然后在modeldemo里实例化调试
    /**
     * @type {{dampingDistance:number,dampingTime:number,easingFunction:string}} GUI控制可修改参数
     */
    this.params = {
      dampingDistance: config.Damping.distance,
      dampingTime: config.Damping.time,
      easingFunction: 'SinusoidalOut'
    }
    /**
     * @type {GUI} GUI控制器
     */
    this.gui = new GUI()
    this.gui.add(this.params, 'dampingDistance', 0.1, 2).name('滑动力量').onChange(this.updateGUI.bind(this))
    this.gui.add(this.params, 'dampingTime', 500, 5000).name('滑动时间').onChange(this.updateGUI.bind(this))
    this.gui.add(this.params, 'easingFunction', [
      'LinearNone',
      'QuadraticIn', 'QuadraticOut', 'QuadraticInOut',
      'CubicIn', 'CubicOut', 'CubicInOut',
      'QuarticIn', 'QuarticOut', 'QuarticInOut',
      'QuinticIn', 'QuinticOut', 'QuinticInOut',
      'SinusoidalIn', 'SinusoidalOut', 'SinusoidalInOut',
      'ExponentialIn', 'ExponentialOut', 'ExponentialInOut',
      'CircularIn', 'CircularOut', 'CircularInOut',
      'ElasticIn', 'ElasticOut', 'ElasticInOut',
      'BackIn', 'BackOut', 'BackInOut',
      'BounceIn', 'BounceOut', 'BounceInOut'
    ]).name('静止模式').onChange(this.updateGUI.bind(this))
  }

  /**
   * 更新函数
   */
  updateGUI () {
    // 写在modeldemo里的Update事件里
    config.Damping.distance = this.params.dampingDistance

    config.Damping.time = this.params.dampingTime

    switch (this.params.easingFunction) {
      case 'LinearNone':
        config.Damping.easingFunction = TWEEN.Easing.Linear.None
        break
      case 'QuadraticOut':
        config.Damping.easingFunction = TWEEN.Easing.Quadratic.Out
        break
      case 'CubicOut':
        config.Damping.easingFunction = TWEEN.Easing.Cubic.Out
        break
      case 'QuarticOut':
        config.Damping.easingFunction = TWEEN.Easing.Quartic.Out
        break
      case 'QuinticOut':
        config.Damping.easingFunction = TWEEN.Easing.Quintic.Out
        break
      case 'SinusoidalOut':
        config.Damping.easingFunction = TWEEN.Easing.Sinusoidal.Out
        break
      case 'ExponentialOut':
        config.Damping.easingFunction = TWEEN.Easing.Exponential.Out
        break
      case 'CircularOut':
        config.Damping.easingFunction = TWEEN.Easing.Circular.Out
        break
      case 'ElasticOut':
        config.Damping.easingFunction = TWEEN.Easing.Elastic.Out
        break
      case 'BackOut':
        config.Damping.easingFunction = TWEEN.Easing.Back.Out
        break
      case 'BounceOut':
        config.Damping.easingFunction = TWEEN.Easing.Bounce.Out
        break

      case 'QuadraticIn':
        config.Damping.easingFunction = TWEEN.Easing.Quadratic.In
        break
      case 'CubicIn':
        config.Damping.easingFunction = TWEEN.Easing.Cubic.In
        break
      case 'QuarticIn':
        config.Damping.easingFunction = TWEEN.Easing.Quartic.In
        break
      case 'QuinticIn':
        config.Damping.easingFunction = TWEEN.Easing.Quintic.In
        break
      case 'SinusoidalIn':
        config.Damping.easingFunction = TWEEN.Easing.Sinusoidal.In
        break
      case 'ExponentialIn':
        config.Damping.easingFunction = TWEEN.Easing.Exponential.In
        break
      case 'CircularIn':
        config.Damping.easingFunction = TWEEN.Easing.Circular.In
        break
      case 'ElasticIn':
        config.Damping.easingFunction = TWEEN.Easing.Elastic.In
        break
      case 'BackIn':
        config.Damping.easingFunction = TWEEN.Easing.Back.In
        break
      case 'BounceIn':
        config.Damping.easingFunction = TWEEN.Easing.Bounce.In
        break

      case 'QuadraticInOut':
        config.Damping.easingFunction = TWEEN.Easing.Quadratic.InOut
        break
      case 'CubicInOut':
        config.Damping.easingFunction = TWEEN.Easing.Cubic.InOut
        break
      case 'QuarticInOut':
        config.Damping.easingFunction = TWEEN.Easing.Quartic.InOut
        break
      case 'QuinticInOut':
        config.Damping.easingFunction = TWEEN.Easing.Quintic.InOut
        break
      case 'SinusoidalInOut':
        config.Damping.easingFunction = TWEEN.Easing.Sinusoidal.InOut
        break
      case 'ExponentialInOut':
        config.Damping.easingFunction = TWEEN.Easing.Exponential.InOut
        break
      case 'CircularInOut':
        config.Damping.easingFunction = TWEEN.Easing.Circular.InOut
        break
      case 'ElasticInOut':
        config.Damping.easingFunction = TWEEN.Easing.Elastic.InOut
        break
      case 'BackInOut':
        config.Damping.easingFunction = TWEEN.Easing.Back.InOut
        break
      case 'BounceInOut':
        config.Damping.easingFunction = TWEEN.Easing.Bounce.InOut
        break
    }
  }
}
